function fixBadWords(texto = '') {
    if (texto) {
        texto = texto.replace('destinatï¿½rio', 'destinatário');
        texto = texto.replace('Destinatï¿½rio', 'Destinatário');
        texto = texto.replace('destinatÃ¡rio', 'destinatário');
        texto = texto.replace('DestinatÃ¡rio', 'Destinatário');
        texto = texto.replace('apï¿½s', 'após');
        texto = texto.replace(/nï¿½o/g, 'não');
        texto = texto.replace('horï¿½rio', 'horário');
        texto = texto.replace('informaï¿½ï¿½o', 'informação');
        texto = texto.replace('endereï¿½o', 'endereço');
        texto = texto.replace('Endereï¿½o', 'Endereço');
        texto = texto.replace('ï¿½rea', 'área');
        texto = texto.replace('Distribuiï¿½ï¿½o', 'Distribuição');
        texto = texto.replace('distribuiï¿½ï¿½o', 'distribuição');
        texto = texto.replace(' ï¿½ ', ' à ');
        texto = texto.replace('Agï¿½ncia', 'Agência');
        texto = texto.replace('Incï¿½ndio', 'Incêndio');
        texto = texto.replace('Logï¿½stica', 'Logística');
        texto = texto.replace('Paï¿½s', 'País');
    }

    return texto;
}

export default fixBadWords;
